/**
@flow strict-local
@format
*/

import AnimationWrapper from './AnimationWrapper';

export default AnimationWrapper;
